
import { Close } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import {
    type SnackbarKey,
    SnackbarProvider,
    type SnackbarProviderProps
  } from 'notistack';
import { useRef } from 'react';
import { InfoIcon, StyledMaterialDesignContent } from '@/app/styles/StyledNotistack';
  
  const MAX_SNACK = 3;
  
  export const NotistackProvider = (props: SnackbarProviderProps) => {
    const notistackRef = useRef<SnackbarProvider>(null);
    const portal = document.querySelector('body') as HTMLElement;
  
    const onClickDismiss = (key: SnackbarKey) => () => {
      notistackRef.current?.closeSnackbar(key);
    };
  
    return (
      <SnackbarProvider
        ref         = {notistackRef}
        maxSnack    = {MAX_SNACK}
        domRoot     = {portal}
        iconVariant = {{ info: <InfoIcon /> }}
        Components={{
          success: StyledMaterialDesignContent,
          error: StyledMaterialDesignContent,
          info: StyledMaterialDesignContent,
          warning: StyledMaterialDesignContent,
        }}
        action      = {(key: SnackbarKey) => (
          <IconButton size="small" onClick={onClickDismiss(key)}>
            <Close sx={{ color: 'common.white' }} />
          </IconButton>
        )}
        {...props}
      />
    );
  };
  